import { render } from "./onChooseCard.vue?vue&type=template&id=fcde24a4&scoped=true&ts=true"
import script from "./onChooseCard.vue?vue&type=script&lang=ts"
export * from "./onChooseCard.vue?vue&type=script&lang=ts"

import "./onChooseCard.vue?vue&type=style&index=0&id=fcde24a4&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcde24a4"]])

export default __exports__